import isString from 'lodash/isString';

const capitalizeFirstLetter = string => {
  if (!isString(string)) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export default capitalizeFirstLetter;
